export const UserRoles = {
    READER: 0,
    WRITER: 1,
    ADMIN: 2,
    SUPERADMIN: 3
};